import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Select } from '@components';
import { AgentFilters, VoiceOption } from '../types';

interface SearchAndFiltersProps {
  filters: AgentFilters;
  onFiltersChange: (filters: AgentFilters) => void;
  voices?: VoiceOption[];
  voicesLoading?: boolean;
}

export const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
  filters,
  onFiltersChange,
  voices = [],
  voicesLoading = false,
}) => {
  const { t } = useTranslation();

  const handleFilterChange = (field: keyof AgentFilters, value: string) => {
    onFiltersChange({ ...filters, [field]: value });
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6">
      <div className="w-full sm:w-80">
        <Input
          type="text"
          placeholder={t('agents.searchAgents')}
          value={filters.search}
          onChange={e => handleFilterChange('search', e.target.value)}
          className="h-10"
        />
      </div>

      <div className="flex gap-4">
        <div className="w-40">
          <Select
            value={filters.status}
            onChange={value =>
              handleFilterChange('status', Array.isArray(value) ? value[0] : value)
            }
            options={[
              { value: '', label: t('agents.allStatus') },
              { value: 'active', label: t('agents.active') },
              { value: 'inactive', label: t('agents.inactive') },
              { value: 'paused', label: t('agents.paused') },
            ]}
            className="h-10"
          />
        </div>

        <div className="w-40">
          <Select
            value={filters.voice}
            onChange={value => handleFilterChange('voice', Array.isArray(value) ? value[0] : value)}
            options={[
              { value: '', label: t('agents.allVoices') },
              ...voices
                .filter(voice => voice.is_active)
                .map(voice => ({
                  value: voice.id,
                  label: voice.name,
                })),
            ]}
            className="h-10"
            disabled={voicesLoading}
          />
        </div>
      </div>
    </div>
  );
};
